/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_Toast_Generate_ErrorInputs */

const en_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to generate cover letter`)
};

const de_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anschreiben konnte nicht generiert werden`)
};

const fr_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de générer la lettre de motivation`)
};

const es_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo generar la carta de presentación`)
};

const it_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione della lettera di presentazione non riuscita`)
};

const nl_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motivatiebrief genereren mislukt`)
};

const pl_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wygenerować listu motywacyjnego`)
};

const fi_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saatekirjeen luominen epäonnistui`)
};

const da_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke generere ansøgningsbrev`)
};

const sv_cover_letters_toast_generate_error = /** @type {(inputs: Cover_Letters_Toast_Generate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunde inte generera personligt brev`)
};

/**
* | output |
* | --- |
* | "Failed to generate cover letter" |
*
* @param {Cover_Letters_Toast_Generate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_toast_generate_error = /** @type {((inputs?: Cover_Letters_Toast_Generate_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_Toast_Generate_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_toast_generate_error(inputs)
	if (locale === "fr") return fr_cover_letters_toast_generate_error(inputs)
	if (locale === "es") return es_cover_letters_toast_generate_error(inputs)
	if (locale === "it") return it_cover_letters_toast_generate_error(inputs)
	if (locale === "nl") return nl_cover_letters_toast_generate_error(inputs)
	if (locale === "pl") return pl_cover_letters_toast_generate_error(inputs)
	if (locale === "fi") return fi_cover_letters_toast_generate_error(inputs)
	if (locale === "da") return da_cover_letters_toast_generate_error(inputs)
	if (locale === "sv") return sv_cover_letters_toast_generate_error(inputs)
	return en_cover_letters_toast_generate_error(inputs)
});